import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNpm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"npm"} maskId="square-filled-radius-0-stroke-1-IconNpm"><path d="M3 21H12V7.5H16.5V21H21V3H3V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNpm;
